import React, { FunctionComponent } from 'react';
import { RegularTitle, SmallTitle, LegalBody } from '@indigo-ag/component-module';

import { createStylesHook } from 'shared';
import { rolesInvolved } from '../utils';

interface TitleWrapProps {
  roles?: string[];
  subject?: string;
  extraSize?: boolean;
}

const useStyles = createStylesHook(() => ({
  titleWrapper: {
    overflow: 'hidden'
  },
  titleWord: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    paddingRight: 9
  }
}));

export const TitleWrap: FunctionComponent<TitleWrapProps> = ({ roles, subject, extraSize }) => {
  /**
   * Styles
   */
  const classes = useStyles();

  const TitleComponent = extraSize ? RegularTitle : SmallTitle;

  return (
    <div className={classes.titleWrapper}>
      {subject ? (
        <>
          <TitleComponent className={classes.titleWord}>{subject}</TitleComponent>
          <LegalBody className={`${classes.titleWord} mt-0`}>{rolesInvolved(roles)}</LegalBody>
        </>
      ) : (
        <TitleComponent className={classes.titleWord}>{rolesInvolved(roles)}</TitleComponent>
      )}
    </div>
  );
};
